import type { CommandServices } from '@wix/cli-command-contract';
import { createCommand } from '@commander-js/extra-typings';
import { domainBuy } from './domain-buy.js';
import { domainSuggest } from './domain-suggest.js';

export const domain = (
  services: CommandServices,
  cliVersion: string,
  configSiteId?: string
) => {
  return createCommand('domain')
    .description('Manage your Wix account domains')
    .addCommand(domainSuggest(services, cliVersion))
    .addCommand(domainBuy(services, cliVersion, configSiteId));
};
